export enum APIType {
    LOCAL,
    STAGING,
    PROD
}